// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"407":"205c5bb9","436":"83d84094","453":"f394a27d","501":"cec23328","606":"9413a471","821":"14ddef66","925":"e5530eb6","969":"b3d3cac4"}[chunkId] + ".chunk.js";
};